"use client";
import { useState } from "react";
const faqs = [
    {
        question: "What is the difference between cardiac, thoracic, and vascular surgery?",
        answer: "Cardiac surgery deals with the heart, thoracic surgery focuses on the lungs and chest cavity, while vascular surgery involves the arteries and veins.",
    },
    {
        question: "How long does recovery take after heart surgery?",
        answer: "Recovery time varies depending on the procedure, but most patients can return to normal activities within 6–8 weeks with proper rehabilitation.",
    },
    {
        question: "Is CTVS safe for older patients?",
        answer: "Yes, with modern technology and skilled surgeons, CTVS procedures are safe even for elderly patients when proper pre-surgical assessment is done.",
    },
    {
        question: "What symptoms indicate the need for cardiac surgery?",
        answer: "Severe chest pain, shortness of breath, valve dysfunction, or heart failure symptoms may indicate the need for surgical evaluation.",
    },
    {
        question: "What types of heart surgeries are performed at HDNA Aarogyam Hospital?",
        answer: " We offer CABG (heart bypass), valve repair or replacement, aortic aneurysm surgery, and congenital heart defect correction using advanced techniques.",
    },
    {
        question: "Are minimally invasive or robotic heart surgeries available?",
        answer: "Yes. HDNA Aarogyam Hospital provides minimally invasive and advanced surgical options that reduce pain, scarring, hospital stay, and recovery time.",
    },
    {
        question: "What conditions are treated under vascular surgery?",
        answer: "Vascular surgery treats blocked arteries, aneurysms, carotid artery disease, varicose veins, and circulation-related disorders.",
    },
    {
        question: "How long is hospital stay after CTVS procedures?",
        answer: "Hospital stay varies by procedure but typically ranges from 5 to 10 days, including ICU monitoring and recovery care.",
    },
    {
        question: "What kind of pre-surgery evaluation is done before CTVS?",
        answer: "Patients undergo detailed cardiac tests, imaging, blood investigations, and risk assessment to ensure safe and personalized treatment planning.",
    },
    {
        question: "Does HDNA Aarogyam Hospital provide post-surgery rehabilitation and follow-up care?",
        answer: "Yes. We offer structured rehabilitation programs, lifestyle counseling, medication management, and regular follow-ups for long-term heart and vascular health.",
    }
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);

    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div
                    key={currentIndex}
                    className="faq-box"
                    onClick={() => toggleFaq(currentIndex)}
                >
                    {/* Question */}
                    <div
                        className={`faq-question ${activeIndex === currentIndex ? "active" : ""
                            }`}
                    >
                        <h6>{faq.question}</h6>

                        <span className="icon">
                            {activeIndex === currentIndex ? "−" : "+"}
                        </span>
                    </div>

                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer">
                            <p>{faq.answer}</p>
                        </div>
                    )}
                </div>

            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>

                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
